import classNames from 'classnames';

var modules_e81895c9 = {"button-shadow":"inset 0 0 0 1px","loaderWidth":"calc(var(--ring-unit)*8)","light":"light_rui_2ac4","heightS":"heightS_rui_6ad6","heightM":"heightM_rui_6ad6","heightL":"heightL_rui_6ad6","button":"button_rui_6ad6","active":"active_rui_6ad6","withIcon":"withIcon_rui_6ad6","icon":"icon_rui_6ad6","primary":"primary_rui_6ad6","loader":"loader_rui_6ad6","loaderBackground":"loaderBackground_rui_6ad6","danger":"danger_rui_6ad6","text":"text_rui_6ad6","content":"content_rui_6ad6","text-loading":"text-loading_rui_6ad6","inline":"inline_rui_6ad6","withNormalIcon":"withNormalIcon_rui_6ad6","withDangerIcon":"withDangerIcon_rui_6ad6","progress":"progress_rui_6ad6","delayed":"delayed_rui_6ad6","short":"short_rui_6ad6","dropdownIcon":"dropdownIcon_rui_6ad6"};

function getButtonClasses(_ref) {
  var className = _ref.className,
    active = _ref.active,
    disabled = _ref.disabled,
    loader = _ref.loader,
    primary = _ref.primary,
    short = _ref.short,
    text = _ref.text,
    inline = _ref.inline,
    danger = _ref.danger,
    delayed = _ref.delayed,
    icon = _ref.icon,
    height = _ref.height;
  var withNormalIcon = icon && !active && !danger && !primary && !disabled;
  return classNames(modules_e81895c9.button, className, modules_e81895c9["height".concat(height)], {
    [modules_e81895c9.active]: active,
    [modules_e81895c9.danger]: danger,
    [modules_e81895c9.delayed]: delayed,
    [modules_e81895c9.withIcon]: icon,
    [modules_e81895c9.withNormalIcon]: withNormalIcon,
    [modules_e81895c9.withDangerIcon]: icon && danger,
    [modules_e81895c9.loader]: loader && !icon,
    [modules_e81895c9.primary]: primary,
    [modules_e81895c9.short]: short,
    [modules_e81895c9.text]: text,
    [modules_e81895c9.inline]: inline
  });
}

export { getButtonClasses as g, modules_e81895c9 as m };
